import styled from 'styled-components/macro';
import * as theme from '../../theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100vw;
  background: linear-gradient(to bottom right, ${theme.palette.highlightTertiary}, ${theme.palette.themePrimary});
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  margin: auto;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
`;

export const Logo = styled.img`
  height: 40px;
`;

export const LogoText = styled.h3`
  color: white;
  margin: 0 0 0 5px;
  padding: 0;
`;

export const InfoContainer = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 1.5rem;
  width: 100%;
  margin-bottom: 1rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
`;

export const Form = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 2rem;
  width: 100%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ValidationContainer = styled.div`
  background: rgba(255, 255, 255);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 1.5rem;
  width: 100%;
  margin-top: 1rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const Title = styled.h1`
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-align: center;
`;

export const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  margin-bottom: 0;
  font-size: 0.9rem;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 1rem;
`;

export const TogglePassword = styled.button`
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0;
  color: ${theme.palette.themePrimary};
  cursor: pointer;
  font-size: 0.9rem;
  opacity: 0.8;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 44px;
  padding: 0 2.5rem 0 1rem;
  border: none;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.9);
  color: rgba(0, 0, 0, 0.9);
  font-size: 1rem;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${theme.palette.themePrimary};
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const Button = styled.button`
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 6px;
  background: ${theme.palette.themePrimary};
  color: white;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const Rule = styled.div`
  display: flex;
  align-items: center;
  margin: 0.25rem 0;
  color: ${({ isValid }) => isValid ? theme.palette.highlightTertiary : theme.palette.themePrimary};
  font-size: 0.85rem;
  opacity: ${({ isValid }) => isValid ? 0.8 : 1};
  transition: all 0.2s ease;

  &:before {
    content: '${({ isValid }) => isValid ? '✓' : 'x'}';
    margin-right: 0.5rem;
    color: ${({ isValid }) => isValid ? theme.palette.highlightTertiary : theme.palette.themePrimary};
  }
`;

export const ErrorMessage = styled.div`
  color: ${theme.palette.white};
  margin-bottom: 1rem;
  text-align: center;
`;

export const LoadingMessage = styled.div`
  color: white;
  text-align: center;
  font-size: 1rem;
`; 